/* eslint-disable */
export abstract class Module {
  constructor(...args) {}
  public abstract init(): void|Promise<void>;
  public cleanup(): void|Promise<void> {}
}
